/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _findIndex from 'lodash/findIndex';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get, sku, qty) => set(
  produce(
    get(),
    (draft) => {
      if (!qty) {
        return;
      }

      const updateExisting = _findIndex(get().design.cart, ['Sku', sku]);

      if (!draft.design) {
        draft.design = {};
      }

      if (updateExisting !== -1) {
        draft.design.cart[updateExisting].Quantity = qty;
      }

      draft.design.selectedProduct = null;

      // logging
      logNewRelicCustom(NEW_RELIC_EVENTS.UPDATE_NON_VISUALIZED_QTY, get().design.cart);
    }),
  false,
  { type: 'UPDATE QTY', payload: {} }
);
